<body>
  <ng-toast></ng-toast>
  <router-outlet></router-outlet>
</body>